/** Retains hydrated state leaves during the pause before React subscribes. */
export const HYDRATED_IDLE_TTL_MS = 1000;
